/**
 * @file Form responsible for resetting password.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { cleanApolloError } from '../../util/normalize-errors';
import InputGroup from '../global/InputGroup';
import Button from '../global/Button';
import Alert from '../global/Alert';
import { getAsset } from '../../util/assets';

class PasswordResetForm extends Component {
  static propTypes = {
    resetPassword: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
  };

  state = {
    loading: false,
    error: '',
    success: false,
  };

  onFormSubmit = async event => {
    event.preventDefault();
    const { resetPassword, token } = this.props;

    this.setState(() => ({ error: '', loading: true }));

    const password = this.password.value;
    const passwordConfirm = this.passwordConfirm.value;

    if (password !== passwordConfirm) {
      this.setState(() => ({
        error: 'Passwords do not match.',
        loading: false,
      }));
      return;
    }

    try {
      await resetPassword(token, password);

      this.setState(() => ({
        error: '',
        loading: false,
        success: true,
      }));
    } catch ({ message }) {
      this.setState(() => ({
        error: cleanApolloError(message),
        loading: false,
      }));
    }
  };

  render() {
    const { error, success } = this.state;

    return (
      <form className="form-password-reset" onSubmit={this.onFormSubmit}>
        <div className="mb-4">
          Great, now enter a new password (and confirm it), to complete
          resetting your password.
        </div>
        {!success && (
          <div>
            <InputGroup
              id="password"
              type="password"
              label="New Password"
              labelSrOnly
              placeholder="New Password"
              name="password"
              required
              addon={
                <img alt="" src={getAsset('/shutterbug/icons/password.svg')} />
              }
              inputRef={ref => {
                this.password = ref;
              }}
            />

            <InputGroup
              id="password-confirm"
              type="password"
              label="Confirm Password"
              labelSrOnly
              placeholder="Confirm Password"
              name="password-confirm"
              required
              addon={
                <img alt="" src={getAsset('/shutterbug/icons/password.svg')} />
              }
              inputRef={ref => {
                this.passwordConfirm = ref;
              }}
            />
            <Button
              type="submit"
              className="btn-block mt-4"
              disabled={this.state.loading}
            >
              Set password
            </Button>
          </div>
        )}

        {error && (
          <Alert type="danger" className="mt-2">
            {error}
          </Alert>
        )}

        {success && (
          <Alert type="success" className="mt-2">
            Password changed successfully! <br />
            <Link to="/shutterbug/signin">
              Click here to sign in to your account.
            </Link>
          </Alert>
        )}
      </form>
    );
  }
}

export default PasswordResetForm;
